import bgCourse from "../img/bg-course.jpg";
import bgAbout from "../img/bg-about.jpg";

const courses = [
  {
    id: "c1",
    title: "Español desde Cero",
    category: "Idiomas",
    level: "Beginner",
    language: "ES",
    rating: 4.8,
    reviews: 1240,
    lessons: 45,
    duration: "12h",
    price: 0,
    tag: "Gratis",
    image: bgCourse,
  },
  {
    id: "c2",
    title: "Conversación en Español B1-B2",
    category: "Idiomas",
    level: "Intermediate",
    language: "ES",
    rating: 4.7,
    reviews: 980,
    lessons: 36,
    duration: "9h",
    price: 49,
    tag: "Popular",
    image: bgAbout,
  },
  {
    id: "c3",
    title: "Inglés para Viajes",
    category: "Idiomas",
    level: "Beginner",
    language: "EN",
    rating: 4.6,
    reviews: 610,
    lessons: 28,
    duration: "6h",
    price: 29,
    tag: "Nuevo",
    image: bgCourse,
  },
  {
    id: "c4",
    title: "React desde Cero",
    category: "Programación",
    level: "Beginner",
    language: "ES",
    rating: 4.9,
    reviews: 3200,
    lessons: 72,
    duration: "18h",
    price: 79,
    tag: "Recomendado",
    image: bgCourse,
  },
  {
    id: "c5",
    title: "JavaScript Avanzado",
    category: "Programación",
    level: "Advanced",
    language: "ES",
    rating: 4.8,
    reviews: 2100,
    lessons: 60,
    duration: "15h",
    price: 89,
    tag: "Top",
    image: bgCourse,
  },
  {
    id: "c6",
    title: "UI/UX Fundamentos",
    category: "Diseño",
    level: "Beginner",
    language: "ES",
    rating: 4.5,
    reviews: 740,
    lessons: 40,
    duration: "10h",
    price: 39,
    tag: "Recomendado",
    image: bgAbout,
  },
  {
    id: "c7",
    title: "Figma Práctico",
    category: "Diseño",
    level: "Intermediate",
    language: "ES",
    rating: 4.7,
    reviews: 560,
    lessons: 34,
    duration: "8h",
    price: 59,
    tag: "Popular",
    image: bgAbout,
  },
  {
    id: "c8",
    title: "Marketing Digital 360°",
    category: "Marketing",
    level: "Intermediate",
    language: "ES",
    rating: 4.6,
    reviews: 1310,
    lessons: 52,
    duration: "13h",
    price: 69,
    tag: "Destacado",
    image: bgCourse,
  },
  {
    id: "c9",
    title: "SEO Técnico",
    category: "Marketing",
    level: "Advanced",
    language: "ES",
    rating: 4.5,
    reviews: 420,
    lessons: 26,
    duration: "7h",
    price: 49,
    tag: "Nuevo",
    image: bgCourse,
  },
  {
    id: "c10",
    title: "Python para Data Science",
    category: "Programación",
    level: "Intermediate",
    language: "ES",
    rating: 4.8,
    reviews: 2750,
    lessons: 66,
    duration: "16h",
    price: 89,
    tag: "Top",
    image: bgCourse,
  },
  {
    id: "c11",
    title: "Pronunciación en Español",
    category: "Idiomas",
    level: "Intermediate",
    language: "ES",
    rating: 4.4,
    reviews: 210,
    lessons: 22,
    duration: "5h",
    price: 19,
    tag: "Corto",
    image: bgAbout,
  },
  {
    id: "c12",
    title: "Vue 3 Completo",
    category: "Programación",
    level: "Advanced",
    language: "ES",
    rating: 4.7,
    reviews: 990,
    lessons: 58,
    duration: "14h",
    price: 79,
    tag: "Recomendado",
    image: bgCourse,
  },
];

export default courses;
